import React from 'react';
import { GiGlobe, GiHouse } from 'react-icons/gi';
import { useParams } from 'react-router-dom';
import Detail from '../components/pages/detail';
import DetailComponent from '../components/details/domestic';
export default () => {
    const {direction, id} = useParams();
    
    const Icon=GiGlobe;
    return (
        <Detail 
            title={`flight_domestic`} 
            icon={Icon} 
            id={id}
            url={`api/v1/flight_schedule/domestic/detail`}
            getBreadcumbValue={({flight_number})=>flight_number}
            breadcrumbs={
                [
                    {
                        href:'/home',
                        icon:<GiHouse color='white' />,
                        item:'home'
                    },
                    {
                        item:'flight_schedule'
                    },
                    {
                        item:'flight_domestic',
                        href:'/flight/domestic'
                    }
                ]
            }
            DetailComponent={DetailComponent}
            additionalData={{direction, id}}
        />
    )
}